import Select from '@atomaro/ui-kit/components/Select/Select';
import { useApiariesStore } from 'entities/apiaries';
import { ApiariesSelectWrapper } from './styles';
import { useMemo } from 'react';
import { IDropdownMenuItem } from '@atomaro/ui-kit/components/DropdownMenu/types';
import { useDebounceCallback } from 'shared/lib/debounce/useDebounce';
import { toRem } from 'shared/helpers';

export const ApiariesSelect = () => {
  const apiaries = useApiariesStore(s => s.apiaries);
  const currentApiaryId = useApiariesStore(s => s.currentApiaryId);
  const setCurrentApiary = useApiariesStore(s => s.setCurrentApiary);

  const items: IDropdownMenuItem[] = useMemo(() => {
    return apiaries.map(el => {
      return {
        key: el.id,
        value: el.name?.trim() || 'Без названия',
      }
    })
  }, [apiaries])

  const onChange = useDebounceCallback((value: string | number) => {
    setCurrentApiary(`${value}`)
  }, 100)

  return (
    <ApiariesSelectWrapper>
      <Select 
        items={items}
        value={currentApiaryId}
        onChange={onChange}
        useInPortal={false}
        dropdownMenuStyle={{
          maxHeight: toRem(300),
          overflowY: 'auto'
        }}
      />
    </ApiariesSelectWrapper>
  )
}